/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 17th 2026, 7:15:28 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useUserContext } from "authentication";
import { APISERVICEPATHS, useAPIRequest } from "lib/api";
import { useStore } from "lib/store";
import { getCookie } from "lib/utils";

export const getCSRFTokenFromCookie = () => {
  const csrfCookieName = Boolean(process.env.REACT_APP_ONESTOP_CSRF_COOKIE_NAME)
    ? process.env.REACT_APP_ONESTOP_CSRF_COOKIE_NAME
    : "csrftoken"; // Use Booolean to provide a default value if the env variable is not set. This handles cases where the env variable maybe be set with encoded chars that may not be detected by javascript. Also Object.is(x, "") works for such cases of ===, ??, ||, etc.
  return getCookie(csrfCookieName);
};

export const SecurityProvider = ({ children }) => {
  const { loggedInUser, sessionIsAuthenticated } = useUserContext();
  const csrfTokenFromCookie = getCSRFTokenFromCookie();
  const { setCSRFToken } = useStore();
  const { makeRequest } = useAPIRequest<string>({
    apiServicePath: APISERVICEPATHS.getCSRFTokenFromBrowser,
    makeRequestOnInitialMount: false,
  });

  React.useEffect(() => {
    if (csrfTokenFromCookie) return setCSRFToken(csrfTokenFromCookie);
    makeRequest({ setValidAPIResponse: setCSRFToken });
    // Include sessionIsAuthenticated in depdendency array so that the correct CSRF Token is picked between authentications.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [csrfTokenFromCookie, loggedInUser?.id, sessionIsAuthenticated]);

  return <>{children}</>;
};
